import { render, staticRenderFns } from "./StepControls.vue?vue&type=template&id=0ecd208e&scoped=true&lang=pug&"
import script from "./StepControls.vue?vue&type=script&lang=ts&"
export * from "./StepControls.vue?vue&type=script&lang=ts&"
import style0 from "./StepControls.vue?vue&type=style&index=0&id=0ecd208e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd208e",
  null
  
)

export default component.exports